let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dRALU")).then(() => parcelRequire('3PK42'));